import React, { useState, useRef, useEffect, useCallback } from "react";
import { Button, Form, Input } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "axios";
import toast from "react-hot-toast";
import { showLoading, hideLoading } from "../redux/alertsSlice";
import {
  EyeInvisibleOutlined,
  EyeTwoTone,
  PhoneOutlined,
  LockOutlined,
  LoginOutlined,
  SafetyOutlined,
  ClockCircleOutlined,
  TeamOutlined,
  SearchOutlined,
  UserOutlined,
  MailOutlined,
  ArrowRightOutlined,
  ArrowLeftOutlined,
  CheckCircleOutlined,
  ReloadOutlined,
} from "@ant-design/icons";

const css = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=Playfair+Display:wght@600;700&display=swap');

  .pp-root * { box-sizing: border-box; margin: 0; padding: 0; }
  .pp-root {
    min-height: 100vh; display: flex; align-items: stretch;
    font-family: 'DM Sans', sans-serif; background: #f0f4f8;
  }
  .pp-left {
    width: 38%;
    background: linear-gradient(160deg, #074f9bff 0%, #0b61bdff 55%, #007BFF 100%);
    display: flex; flex-direction: column; justify-content: center;
    gap: 36px; padding: 52px 44px; position: relative; overflow: hidden;
  }
  .pp-left::before {
    content: ''; position: absolute; top: -80px; right: -80px;
    width: 320px; height: 320px; border-radius: 50%;
    background: rgba(255,255,255,0.05);
  }
  .pp-left::after {
    content: ''; position: absolute; bottom: -120px; left: -60px;
    width: 400px; height: 400px; border-radius: 50%;
    background: rgba(255,255,255,0.04);
  }
  .pp-logo-icon {
    width: 64px; height: 64px; background: rgba(255,255,255,0.15);
    border-radius: 18px; display: flex; align-items: center; justify-content: center;
    font-size: 28px; color: #fff; margin-bottom: 24px;
    backdrop-filter: blur(4px); border: 1px solid rgba(255,255,255,0.2);
  }
  .pp-brand-block { position: relative; z-index: 1; }
  .pp-brand-title {
    font-family: 'Playfair Display', serif; font-size: 28px; font-weight: 700;
    color: #fff; line-height: 1.2; margin-bottom: 10px;
  }
  .pp-brand-sub { font-size: 14px; color: rgba(255,255,255,0.72)!important; line-height: 1.6; }
  .pp-features { display: flex; flex-direction: column; gap: 14px; position: relative; z-index: 1; }
  .pp-feat-item {
    display: flex; align-items: center; gap: 14px;
    color: rgba(255,255,255,0.88); font-size: 14px; font-weight: 500;
  }
  .pp-feat-icon {
    width: 38px; height: 38px; background: rgba(255,255,255,0.12);
    border-radius: 10px; display: flex; align-items: center; justify-content: center;
    font-size: 16px; flex-shrink: 0; border: 1px solid rgba(255,255,255,0.15);
  }
  .pp-left-footer {
    font-size: 12px; color: rgba(255,255,255,0.45);
    position: absolute; bottom: 28px; left: 44px; right: 44px; z-index: 1;
  }
  .pp-right {
    flex: 1; display: flex; align-items: center; justify-content: center;
    padding: 40px 24px; background: #f8fafc;
  }
  .pp-form-box { width: 100%; max-width: 460px; }
  .pp-steps { display: flex; align-items: flex-start; margin-bottom: 32px; }
  .pp-step {
    display: flex; flex-direction: column; align-items: center;
    gap: 6px; flex: 1; position: relative;
  }
  .pp-step:not(:last-child)::after {
    content: ''; position: absolute; top: 16px; left: 50%;
    width: 100%; height: 2px; background: #e2e8f0; z-index: 0;
  }
  .pp-step.done::after  { background: #007BFF; }
  .pp-step.active::after { background: #007BFF; }
  .pp-step-dot {
    width: 32px; height: 32px; border-radius: 50%; background: #e2e8f0;
    display: flex; align-items: center; justify-content: center;
    font-size: 13px; font-weight: 600; color: #94a3b8;
    position: relative; z-index: 1; transition: all 0.3s ease;
  }
  .pp-step.active .pp-step-dot {
    background: #217559; color: #fff;
    box-shadow: 0 0 0 4px rgba(33,117,89,0.15);
  }
  .pp-step.done .pp-step-dot { background: #007BFF; color: #fff; }
  .pp-step-label { font-size: 11px; color: #94a3b8; font-weight: 500; white-space: nowrap; }
  .pp-step.active .pp-step-label { color: #0854a5ff; font-weight: 600; }
  .pp-step.done  .pp-step-label { color: #007BFF; }
  .pp-form-title {
    font-family: 'Playfair Display', serif;
    font-size: 26px; font-weight: 700; color: #0f172a; margin-bottom: 6px;
  }
  .pp-form-sub { font-size: 14px; color: #64748b; margin-bottom: 28px; }
  .pp-input .ant-input,
  .pp-input .ant-input-affix-wrapper {
    border-radius: 10px !important; border: 1.5px solid #e2e8f0 !important;
    padding: 12px 14px !important; font-size: 14px !important;
    background: #fff !important; transition: all 0.2s !important;
  }
  .pp-input .ant-input:focus,
  .pp-input .ant-input-affix-wrapper-focused {
    border-color: #217559 !important;
    box-shadow: 0 0 0 3px rgba(33,117,89,0.1) !important;
  }
  .pp-input .ant-form-item-label label {
    font-weight: 600 !important; color: #374151 !important; font-size: 13px !important;
  }
  .pp-btn {
    height: 50px !important; border-radius: 12px !important;
    font-weight: 600 !important; font-size: 15px !important; letter-spacing: 0.3px !important;
    background: linear-gradient(135deg, #0b5aaeff, #007BFF) !important;
    border: none !important; transition: all 0.2s !important;
  }
  .pp-btn:hover {
    transform: translateY(-1px) !important;
    box-shadow: 0 6px 20px rgba(33,117,89,0.35) !important; opacity: 0.95 !important;
  }
  .pp-btn-ghost {
    height: 50px !important; border-radius: 12px !important;
    font-weight: 600 !important; font-size: 15px !important;
    background: #f1f5f9 !important; border: 1.5px solid #e2e8f0 !important;
    color: #374151 !important;
  }
  .pp-patient-card {
    background: linear-gradient(135deg, #f0fdf4, #dcfce7);
    border: 1.5px solid #bbf7d0; border-radius: 14px; padding: 18px 20px;
    margin-bottom: 22px; display: flex; align-items: center; gap: 16px;
  }
  .pp-patient-avatar {
    width: 52px; height: 52px; border-radius: 50%;
    background: linear-gradient(135deg, #217559, #14a876);
    display: flex; align-items: center; justify-content: center;
    font-size: 22px; color: #fff; flex-shrink: 0;
  }
  .pp-patient-name  { font-weight: 700; font-size: 16px; color: #0f172a; margin-bottom: 3px; }
  .pp-patient-meta  { font-size: 12px; color: #64748b; display: flex; flex-direction: column; gap: 2px; }
  .pp-otp-row       { display: flex; gap: 10px; justify-content: center; margin-bottom: 24px; }
  .pp-success-icon {
    width: 80px; height: 80px; border-radius: 50%;
    background: linear-gradient(135deg, #0457b0ff, #007BFF);
    display: flex; align-items: center; justify-content: center;
    font-size: 38px; color: #fff; margin: 0 auto 24px;
    box-shadow: 0 8px 24px rgba(33,117,89,0.3);
    animation: pp-pop 0.5s cubic-bezier(.34,1.56,.64,1) both;
  }
  @keyframes pp-pop {
    from { transform: scale(0); opacity: 0; }
    to   { transform: scale(1); opacity: 1; }
  }
  .pp-tabs {
    display: flex; background: #f1f5f9; border-radius: 12px;
    padding: 4px; margin-bottom: 28px;
  }
  .pp-tab {
    flex: 1; padding: 10px 0; text-align: center; border-radius: 9px;
    font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.25s;
    color: #64748b; border: none; background: transparent;
  }
  .pp-tab.active { background: #fff; color: #217559; box-shadow: 0 2px 8px rgba(0,0,0,0.08); }
  .pp-switch-btn {
    margin-top: 20px !important; height: 46px !important;
    border-radius: 12px !important; font-weight: 600 !important; font-size: 13px !important;
    background: #fff !important; border: 1.5px solid #007BFF !important; color: #007BFF !important;
  }
  .pp-link { color: #007BFF; font-weight: 600; text-decoration: none; }
  .pp-link:hover { text-decoration: underline; }
  @media (max-width: 768px) {
    .pp-left { display: none; }
    .pp-right { padding: 30px 16px; }
  }

.pp-logo-icon {
  width: 72px;
  height: 72px;
  background: rgba(255,255,255,0.15);
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255,255,255,0.2);
}

.pp-logo-image {
  width: 56px;
  height: 56px;
  object-fit: contain;
}
`;

// ─────────────────────────────────────────────────────────────
//  OTPTimerDisplay — isolated so its per-second setState never
//  re-renders PatientPortal (and the OTP inputs).
// ─────────────────────────────────────────────────────────────
const OTPTimerDisplay = ({ resetKey, onResend }) => {
  const [timer, setTimer]         = useState(60);
  const [canResend, setCanResend] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    setTimer(60);
    setCanResend(false);
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setTimer((t) => {
        if (t <= 1) { clearInterval(intervalRef.current); setCanResend(true); return 0; }
        return t - 1;
      });
    }, 1000);
    return () => clearInterval(intervalRef.current);
  }, [resetKey]);

  return (
    <div style={{ textAlign: "center", marginBottom: 20, fontSize: 13, color: "#64748b" }}>
      {canResend ? (
        <button
          onClick={onResend}
          style={{ color: "#217559", fontWeight: 600, background: "none", border: "none", cursor: "pointer" }}
        >
          <ReloadOutlined style={{ marginRight: 5 }} />Resend OTP
        </button>
      ) : (
        <span>Resend in <strong style={{ color: "#217559" }}>{timer}s</strong></span>
      )}
    </div>
  );
};

// ─────────────────────────────────────────────────────────────
//  STEPS  (SELECT_PATIENT added — family picker)
// ─────────────────────────────────────────────────────────────
const STEPS = {
  HOME: "home",
  SELECT_PATIENT: "select_patient",
  PATIENT_FOUND: "patient_found",
  OTP: "otp",
  SET_PASSWORD: "set_password",
  SUCCESS: "success",
};
const STEP_LABELS = ["Search", "Verify", "Password", "Done"];

// ─────────────────────────────────────────────────────────────
//  COMPONENT
// ─────────────────────────────────────────────────────────────
function PatientPortal() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loginForm]    = Form.useForm();
  const [searchForm]   = Form.useForm();
  const [passwordForm] = Form.useForm();

  const [tab,         setTab]         = useState("login");
  const [step,        setStep]        = useState(STEPS.HOME);
  const [isLoading,   setIsLoading]   = useState(false);
  const [patientData, setPatientData] = useState(null);
  const [familyList,  setFamilyList]  = useState([]);   // ← multi-patient lookup
  const [otp,         setOtp]         = useState(Array(6).fill(""));
  const [otpResetKey, setOtpResetKey] = useState(0);

  const otpRefs = useRef([]);

  const searchStepIndex = {
    [STEPS.HOME]:           -1,
    [STEPS.SELECT_PATIENT]:  0,
    [STEPS.PATIENT_FOUND]:   0,
    [STEPS.OTP]:             1,
    [STEPS.SET_PASSWORD]:    2,
    [STEPS.SUCCESS]:         3,
  }[step];

  // Reusable: bail out of the search flow back to the login tab
  const backToLogin = useCallback(() => {
    setPatientData(null);
    setFamilyList([]);
    setStep(STEPS.HOME);
    setTab("login");
  }, []);

  // ── API calls ────────────────────────────────────────────────

  const handleLogin = async (values) => {
    setIsLoading(true);
    try {
      dispatch(showLoading());
      const res = await axios.post("/api/patient/login", values);
      dispatch(hideLoading());

      if (res.data.success) {
        toast.success(res.data.message);
        localStorage.setItem("patientToken", res.data.data);
        navigate("/patient/patientdashboard", { replace: true });
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      dispatch(hideLoading());
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = async (values) => {
    setIsLoading(true);
    try {
      dispatch(showLoading());
      const res = await axios.post("/api/patient/lookup", { phone: values.searchPhone });
      dispatch(hideLoading());

      if (!res.data.success) {
        toast.error(res.data.message || "Patient not found");
        return;
      }

      // Number already has a portal account → go log in instead
      if (res.data.portal?.exists) {
        toast(
          res.data.portal.isActive
            ? `This number is already registered under ${res.data.portal.ownerName || "an existing account"}. ` +
              `Sign in — family members appear there as dependents.`
            : "The account on this number is inactive. Please contact support.",
          { icon: "ℹ️", duration: 5000 }
        );
        if (res.data.portal.isActive) setTab("login");
        return;
      }

      // New shape: full family list (fall back to single `patient`)
      const list = res.data.patients?.length
        ? res.data.patients
        : res.data.patient ? [res.data.patient] : [];

      if (!list.length) {
        toast.error("Patient not found");
        return;
      }

      if (list.length === 1) {
        setFamilyList(list);
        setPatientData(list[0]);
        setStep(STEPS.PATIENT_FOUND);
      } else {
        setFamilyList(list);
        setStep(STEPS.SELECT_PATIENT);
      }
    } catch (err) {
      dispatch(hideLoading());
      toast.error(err.response?.data?.message || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSendOTP = async () => {
    setIsLoading(true);
    try {
      dispatch(showLoading());
      await axios.post("/api/patient/send-otp", {
        patientId: patientData.id,
        email:     patientData.email,
        phone:     patientData.phone,
        fullName:  patientData.fullName,   // used in the OTP email template
      });
      dispatch(hideLoading());
      toast.success("OTP sent to your email / phone");
      setOtpResetKey((k) => k + 1);
      setStep(STEPS.OTP);
    } catch (err) {
      dispatch(hideLoading());
      const status = err.response?.status;
      const data   = err.response?.data;

      if (status === 409) {
        // NEW: number belongs to the family's existing portal account
        if (data?.registeredAsFamily) {
          if (data.is_active) {
            toast(data.message, { icon: "👨‍👩‍👧", duration: 6000 });
            setTimeout(backToLogin, 1500);
          } else {
            toast.error(data.message);
          }
          return;
        }
        // NEW: email already linked to another portal account
        if (data?.emailTaken) {
          toast.error(data.message);
          return;
        }
        // Existing: this exact patient already registered
        if (data?.registered) {
          if (data.is_active) {
            toast.success("You already have a portal account. Please log in.");
            setTimeout(backToLogin, 2000);
          } else {
            toast.error("Your account is inactive. Please contact the hospital support desk.");
          }
          return;
        }
        toast.error(data?.message || "Registration conflict. Please log in instead.");
        return;
      }

      if (status === 400) { toast.error(data?.message || "Missing required information."); return; }
      if (status === 500) { toast.error("Failed to deliver OTP on all channels. Please try again."); return; }
      toast.error(data?.message || "Failed to send OTP. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendOTP = async () => {
    setOtp(Array(6).fill(""));
    await handleSendOTP();
  };

  // ── OTP input handlers ───────────────────────────────────────

  const focusInput = useCallback((index) => {
    setTimeout(() => {
      otpRefs.current[index]?.focus();
      otpRefs.current[index]?.select();
    }, 0);
  }, []);

  const handleOtpInput = useCallback((e, i) => {
    const raw = e.target.value.replace(/\D/g, "");
    if (!raw) {
      setOtp((prev) => { const next = [...prev]; next[i] = ""; return next; });
      return;
    }
    if (raw.length > 1) {
      setOtp((prev) => {
        const next = [...prev];
        raw.split("").slice(0, 6 - i).forEach((ch, offset) => { next[i + offset] = ch; });
        return next;
      });
      focusInput(Math.min(i + raw.length, 5));
      return;
    }
    setOtp((prev) => { const next = [...prev]; next[i] = raw; return next; });
    if (i < 5) focusInput(i + 1);
  }, [focusInput]);

  const handleOtpKeyDown = useCallback((e, i) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      setOtp((prev) => {
        const next = [...prev];
        if (next[i]) { next[i] = ""; return next; }
        if (i > 0)   { next[i - 1] = ""; focusInput(i - 1); }
        return next;
      });
    } else if (e.key === "ArrowLeft"  && i > 0) { focusInput(i - 1); }
      else if (e.key === "ArrowRight" && i < 5) { focusInput(i + 1); }
  }, [focusInput]);

  const handleOtpPaste = useCallback((e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    setOtp((prev) => {
      const next = [...prev];
      pasted.split("").forEach((ch, idx) => { next[idx] = ch; });
      return next;
    });
    focusInput(Math.min(pasted.length, 5));
  }, [focusInput]);

  const handleVerifyOTP = async () => {
    const code = otp.join("");
    if (code.length < 6) { toast.error("Enter all 6 digits"); return; }
    setIsLoading(true);
    try {
      dispatch(showLoading());
      const res = await axios.post("/api/patient/verify-otp", { patientId: patientData.id, otp: code });
      dispatch(hideLoading());
      if (res.data.success) { toast.success("OTP verified!"); setStep(STEPS.SET_PASSWORD); }
      else toast.error(res.data.message || "Invalid OTP");
    } catch { dispatch(hideLoading()); toast.error("Verification failed"); }
    finally  { setIsLoading(false); }
  };

  const handleSetPassword = async (values) => {
    setIsLoading(true);
    try {
      dispatch(showLoading());
      const res = await axios.post("/api/patient/register-portal", {
        patientId: patientData.id,
        password:  values.password,
      });
      dispatch(hideLoading());
      if (res.data.success) {
        localStorage.setItem("patientToken", res.data.data);
        setStep(STEPS.SUCCESS);
      } else toast.error(res.data.message);
    } catch (err) {
      dispatch(hideLoading());
      toast.error(err.response?.data?.message || "Something went wrong");
    }
    finally { setIsLoading(false); }
  };

  // ── Helpers (null-safe) ──────────────────────────────────────

  const maskEmail = (e) => {
    if (!e || typeof e !== "string" || !e.includes("@")) return null;
    const [l, d] = e.split("@");
    return l.slice(0, 2) + "***@" + d;
  };

  const maskPhone = (p) => {
    if (!p) return null;
    const s = String(p).replace(/\D/g, "");
    return s.length >= 7 ? s.slice(0, 4) + "****" + s.slice(-3) : s;
  };

  const otpChannels = (pd) =>
    [
      maskEmail(pd?.email) && { icon: "email", label: maskEmail(pd.email) },
      maskPhone(pd?.phone) && { icon: "phone", label: maskPhone(pd.phone) },
    ].filter(Boolean);

  // ── Sub-renders ──────────────────────────────────────────────

  const StepIndicator = () => (
    <div className="pp-steps">
      {STEP_LABELS.map((label, i) => {
        const cls = i < searchStepIndex ? "done" : i === searchStepIndex ? "active" : "";
        return (
          <div key={label} className={`pp-step ${cls}`}>
            <div className="pp-step-dot">
              {i < searchStepIndex ? <CheckCircleOutlined /> : i + 1}
            </div>
            <span className="pp-step-label">{label}</span>
          </div>
        );
      })}
    </div>
  );

  const LoginTab = () => (
    <>
      <h2 className="pp-form-title">Patient Login</h2>
      <p className="pp-form-sub">Sign in with your phone number and password</p>
      <Form form={loginForm} layout="vertical" onFinish={handleLogin} className="pp-input">
        <Form.Item name="phone" label="Phone Number"
          rules={[{ required: true, message: "Phone number required" }]}>
          <Input prefix={<PhoneOutlined style={{ color: "#94a3b8" }} />}
            placeholder="+1 234 567 8900" size="large" />
        </Form.Item>
        <Form.Item name="password" label="Password"
          rules={[{ required: true, message: "Password required" }]}>
          <Input.Password prefix={<LockOutlined style={{ color: "#94a3b8" }} />}
            placeholder="••••••••"
            iconRender={(v) => (v ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
            size="large" />
        </Form.Item>
        <div style={{ textAlign: "right", marginTop: -10, marginBottom: 18 }}>
          <a href="/forget-password" className="pp-link" style={{ fontSize: 13 }}>Forgot Password?</a>
        </div>
        <Form.Item>
          <Button type="primary" htmlType="submit" block size="large"
            loading={isLoading} icon={<LoginOutlined />} className="pp-btn">
            {isLoading ? "Signing In…" : "Login to Portal"}
          </Button>
        </Form.Item>
      </Form>
    </>
  );

  const SearchTab = () => (
    <>
      <h2 className="pp-form-title">Find Your Account</h2>
      <p className="pp-form-sub">Enter your registered phone number to look up your patient record</p>
      <Form form={searchForm} layout="vertical" onFinish={handleSearch} className="pp-input">
        <Form.Item name="searchPhone" label="Registered Phone Number"
          rules={[{ required: true, message: "Phone number required" }]}>
          <Input prefix={<PhoneOutlined style={{ color: "#94a3b8" }} />}
            placeholder="+1 234 567 8900" size="large" />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" block size="large"
            loading={isLoading} icon={<SearchOutlined />} className="pp-btn">
            {isLoading ? "Searching…" : "Search Patient Record"}
          </Button>
        </Form.Item>
      </Form>
    </>
  );

  // ── Family picker (multiple patients on the number) ──────────
  const SelectPatientStep = () => (
    <>
      <StepIndicator />
      <h2 className="pp-form-title">Select Your Record</h2>
      <p className="pp-form-sub">
        {familyList.length} patients are registered on this phone number. Choose who is creating the account —
        the others will be available as dependents after you sign in.
      </p>

      <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 20 }}>
        {familyList.map((p) => (
          <button
            key={p.id}
            onClick={() => { setPatientData(p); setStep(STEPS.PATIENT_FOUND); }}
            style={{
              display: "flex", alignItems: "center", gap: 14, width: "100%",
              textAlign: "left", background: "#fff",
              border: "1.5px solid #e2e8f0", borderRadius: 14,
              padding: "13px 16px", cursor: "pointer", transition: "all 0.2s",
            }}
            onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#007BFF"; e.currentTarget.style.background = "#f0f7ff"; }}
            onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.background = "#fff"; }}
          >
            <div className="pp-patient-avatar" style={{ width: 44, height: 44, fontSize: 18 }}>
              <UserOutlined />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div className="pp-patient-name" style={{ fontSize: 14 }}>
                {p.fullName || `Patient ${p.prn}`}
              </div>
              <div style={{ fontSize: 11.5, color: "#64748b" }}>
                {p.prn}
                {p.age != null ? ` · ${p.age} yrs` : ""}
                {p.gender ? ` · ${p.gender}` : ""}
              </div>
              <div style={{ fontSize: 11.5, color: maskEmail(p.email) ? "#64748b" : "#b45309" }}>
                {maskEmail(p.email) || "No email on record"}
              </div>
            </div>
            <ArrowRightOutlined style={{ color: "#94a3b8", flexShrink: 0 }} />
          </button>
        ))}
      </div>

      <Button block size="large" className="pp-btn-ghost" icon={<ArrowLeftOutlined />}
        onClick={() => { setFamilyList([]); setStep(STEPS.HOME); }}>
        Back
      </Button>
    </>
  );

  const PatientFoundStep = () => {
    const channels = otpChannels(patientData);
    const hasEmail = !!maskEmail(patientData?.email);
    const hasPhone = !!maskPhone(patientData?.phone);
    // Back goes to the family picker when there was one, else Home
    const backTarget = familyList.length > 1 ? STEPS.SELECT_PATIENT : STEPS.HOME;

    return (
      <>
        <StepIndicator />
        <h2 className="pp-form-title">Patient Found</h2>
        <p className="pp-form-sub">Please confirm this is you before we send a verification code</p>

        <div className="pp-patient-card">
          <div className="pp-patient-avatar"><UserOutlined /></div>
          <div style={{ flex: 1 }}>
            <div className="pp-patient-name">{patientData?.fullName || "Patient"}</div>
            <div className="pp-patient-meta">
              {hasEmail ? (
                <span><MailOutlined style={{ marginRight: 5 }} />{maskEmail(patientData.email)}</span>
              ) : (
                <span style={{ color: "#b45309" }}>
                  <MailOutlined style={{ marginRight: 5 }} />No email on record
                </span>
              )}
              {hasPhone && (
                <span><PhoneOutlined style={{ marginRight: 5 }} />{maskPhone(patientData.phone)}</span>
              )}
            </div>
          </div>
          <CheckCircleOutlined style={{ fontSize: 22, color: "#217559" }} />
        </div>

        {channels.length > 0 ? (
          <p style={{ fontSize: 13, color: "#64748b", marginBottom: 20, lineHeight: 1.6 }}>
            We will send a one-time password to{" "}
            {channels.map((c, i) => (
              <React.Fragment key={c.icon}>
                {i > 0 && " and "}
                your {c.icon} <strong>{c.label}</strong>
              </React.Fragment>
            ))}.
          </p>
        ) : (
          <p style={{
            fontSize: 13, color: "#b45309", marginBottom: 20, lineHeight: 1.6,
            background: "#fffbeb", border: "1px solid #fcd34d",
            borderRadius: 10, padding: "10px 14px",
          }}>
            This record has no email or phone number we can send a code to.
            Please visit the front desk to update your contact details first.
          </p>
        )}

        <div style={{ display: "flex", gap: 12 }}>
          <Button block size="large" className="pp-btn-ghost" icon={<ArrowLeftOutlined />}
            onClick={() => { setPatientData(null); setStep(backTarget); }}>Back</Button>
          <Button type="primary" block size="large" loading={isLoading}
            disabled={channels.length === 0}
            icon={<ArrowRightOutlined />} className="pp-btn" onClick={handleSendOTP}>
            Send OTP
          </Button>
        </div>
      </>
    );
  };

  const OTPStep = () => (
    <>
      <StepIndicator />
      <h2 className="pp-form-title">Verify Identity</h2>
      <p className="pp-form-sub" style={{ marginBottom: 28 }}>
        Enter the 6-digit code sent to{" "}
        <strong>{maskEmail(patientData?.email) || maskPhone(patientData?.phone) || "your contact"}</strong>
      </p>
      <div className="pp-otp-row">
        {otp.map((digit, i) => (
          <input
            key={i}
            ref={(el) => (otpRefs.current[i] = el)}
            value={digit}
            type="text"
            inputMode="numeric"
            autoComplete={i === 0 ? "one-time-code" : "off"}
            maxLength={6}
            onInput={(e) => handleOtpInput(e, i)}
            onKeyDown={(e) => handleOtpKeyDown(e, i)}
            onPaste={handleOtpPaste}
            onFocus={(e) => e.target.select()}
            style={{
              width: 52, height: 58, textAlign: "center",
              fontSize: 22, fontWeight: 700, borderRadius: 12,
              border: `2px solid ${digit ? "#217559" : "#e2e8f0"}`,
              color: "#217559", background: digit ? "#f0fdf4" : "#fff",
              outline: "none", transition: "all 0.2s",
              caretColor: "transparent",
              WebkitTapHighlightColor: "transparent",
              fontFamily: "'DM Sans', sans-serif",
            }}
          />
        ))}
      </div>

      <OTPTimerDisplay resetKey={otpResetKey} onResend={handleResendOTP} />

      <div style={{ display: "flex", gap: 12 }}>
        <Button block size="large" className="pp-btn-ghost" icon={<ArrowLeftOutlined />}
          onClick={() => setStep(STEPS.PATIENT_FOUND)}>Back</Button>
        <Button type="primary" block size="large" loading={isLoading}
          icon={<CheckCircleOutlined />} className="pp-btn" onClick={handleVerifyOTP}>
          Verify Code
        </Button>
      </div>
    </>
  );

  const SetPasswordStep = () => (
    <>
      <StepIndicator />
      <h2 className="pp-form-title">Create Password</h2>
      <p className="pp-form-sub">Set a secure password for your patient portal account</p>
      <Form form={passwordForm} layout="vertical" onFinish={handleSetPassword} className="pp-input">
        <Form.Item name="password" label="New Password"
          rules={[{ required: true, message: "Password required" }, { min: 8, message: "At least 8 characters" }]}>
          <Input.Password prefix={<LockOutlined style={{ color: "#94a3b8" }} />}
            placeholder="Min. 8 characters"
            iconRender={(v) => (v ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
            size="large" />
        </Form.Item>
        <Form.Item name="confirmPassword" label="Confirm Password"
          dependencies={["password"]}
          rules={[
            { required: true, message: "Please confirm your password" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value) return Promise.resolve();
                return Promise.reject("Passwords do not match");
              },
            }),
          ]}>
          <Input.Password prefix={<LockOutlined style={{ color: "#94a3b8" }} />}
            placeholder="Re-enter password"
            iconRender={(v) => (v ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
            size="large" />
        </Form.Item>
        <div style={{ display: "flex", gap: 12 }}>
          <Button block size="large" className="pp-btn-ghost" icon={<ArrowLeftOutlined />}
            onClick={() => setStep(STEPS.OTP)}>Back</Button>
          <Button type="primary" htmlType="submit" block size="large"
            loading={isLoading} icon={<CheckCircleOutlined />} className="pp-btn">
            {isLoading ? "Setting up…" : "Confirm & Continue"}
          </Button>
        </div>
      </Form>
    </>
  );

  const SuccessStep = () => (
    <div style={{ textAlign: "center", padding: "20px 0" }}>
      <StepIndicator />
      <div className="pp-success-icon"><CheckCircleOutlined /></div>
      <h2 className="pp-form-title" style={{ textAlign: "center" }}>
        You're all set{patientData?.fullName ? `, ${patientData.fullName.trim().split(/\s+/)[0]}` : ""}!
      </h2>
      <p className="pp-form-sub" style={{ textAlign: "center", marginBottom: 30 }}>
        Your patient portal account has been created successfully.
        {familyList.length > 1 && " Your family members are available inside as dependents."}
      </p>
      <Button type="primary" block size="large" icon={<LoginOutlined />}
        className="pp-btn" onClick={() => navigate("/patient/patientdashboard", { replace: true })}>
        Go to My Dashboard
      </Button>
    </div>
  );

  // ── RENDER ───────────────────────────────────────────────────
  return (
    <>
      <style>{css}</style>
      <div className="pp-root">
        <div className="pp-left">
          <div className="pp-brand-block">
            <div className="pp-logo-icon">
              <img
                src="/atantis-logo.png"
                alt="Atlantis Pediatric Hospital"
                className="pp-logo-image"
              />
            </div>
            <h1 className="pp-brand-title">Atlantis Pediatric hospital Patient Portal</h1>
            <p className="pp-brand-sub">HealthWyse: Secure, unified access to patient health data.</p>
          </div>
          <div className="pp-features">
            <div className="pp-feat-item">
              <div className="pp-feat-icon"><SafetyOutlined /></div>
              <span>HIPAA Compliant &amp; Secure</span>
            </div>
            <div className="pp-feat-item">
              <div className="pp-feat-icon"><ClockCircleOutlined /></div>
              <span>Connects data security directly to operational efficiency</span>
            </div>
            <div className="pp-feat-item">
              <div className="pp-feat-icon"><TeamOutlined /></div>
              <span>Connected to Your Provider</span>
            </div>
          </div>
          <div className="pp-left-footer">© 2025 Bravo Health Limited. All rights reserved.</div>
        </div>

        <div className="pp-right">
          <div className="pp-form-box">
            {step === STEPS.HOME && (
              <>
                <div className="pp-tabs">
                  <button className={`pp-tab ${tab === "login"  ? "active" : ""}`} onClick={() => setTab("login")}>
                    <LoginOutlined style={{ marginRight: 6 }} />Login
                  </button>
                  <button className={`pp-tab ${tab === "search" ? "active" : ""}`} onClick={() => setTab("search")}>
                    <SearchOutlined style={{ marginRight: 6 }} />Find My Account
                  </button>
                </div>
                {tab === "login" ? <LoginTab /> : <SearchTab />}
                <div style={{ textAlign: "center", marginTop: 20 }}>
                  <Link to="/login">
                    <Button block size="large" className="pp-switch-btn" icon={<LoginOutlined />}>
                      Switch to Appointment Portal
                    </Button>
                  </Link>
                </div>
              </>
            )}
            {step === STEPS.SELECT_PATIENT && <SelectPatientStep />}
            {step === STEPS.PATIENT_FOUND  && <PatientFoundStep />}
            {step === STEPS.OTP            && <OTPStep />}
            {step === STEPS.SET_PASSWORD   && <SetPasswordStep />}
            {step === STEPS.SUCCESS        && <SuccessStep />}
          </div>
        </div>
      </div>
    </>
  );
}

export default PatientPortal;